import { filterActivitiesForFeed } from './activityFeedFilters';

// Restore only authorized standalone media from the bounded social window.
// Workout status is already represented by the activity-type member selector;
// it must not create a second, progress-only historical day surface.
export function addHistoricalDojoDayGroups(groups, {
  personalActivities, dojoByDate, getDateKey, formatDate, filters,
  currentUserId, dojoUsers = [],
}) {
  const byDate = new Map(groups.map(group => [group.dateKey, group]));
  // These are social posts, never personal tasks. The server already applies
  // per-owner audiences (including chief-only); the roster is an extra guard,
  // not permission to infer or expand visibility from membership alone.
  const memberIds = new Set(dojoUsers.map(user => user?._id || user?.user_id || user?.id).filter(Boolean).map(String));
  const ownedIds = new Set(personalActivities.map(activity => String(activity._id)));
  const seen = new Set();
  Object.values(dojoByDate).flat().forEach(activity => {
    if (!currentUserId || !activity.user_id || activity.type !== 'media' || !activity._id
        || !memberIds.has(String(activity.user_id)) || String(activity.user_id) === String(currentUserId)
        || ownedIds.has(String(activity._id)) || seen.has(String(activity._id))
        || !['complete', 'completed'].includes(activity.status)
        || !Number.isFinite(Date.parse(activity.completed_at))
        || !activity.data?.files?.some(file => file._id && /^(image|video)\//.test(file.type))) return;
    seen.add(String(activity._id));
    const dateKey = getDateKey(activity.completed_at);
    if ((filters?.startDate && dateKey < filters.startDate) || (filters?.endDate && dateKey > filters.endDate)
        || !filterActivitiesForFeed([{ ...activity, status: 'complete' }], filters).length) return;
    const group = byDate.get(dateKey) || {
      dateKey, date: formatDate(dateKey), types: {},
      nutrition: { calories: 0, protein: 0, carbs: 0, fat: 0, water_ml: 0 }, workoutBurned: 0,
    };
    byDate.set(dateKey, { ...group, sharedMedia: [...(group.sharedMedia || []), activity] });
  });
  byDate.forEach(group => group.sharedMedia?.sort((a, b) => (
    Date.parse(b.completed_at) - Date.parse(a.completed_at) || String(a._id).localeCompare(String(b._id))
  )));
  return [...byDate.values()].sort((a, b) => b.dateKey.localeCompare(a.dateKey));
}
